import React from 'react'
import { Modal } from 'components/Modal'
import invalidateClosing from '../gql/invalidateClosing'
import { useMutation } from 'components/graphql'
import { TextArea } from 'components/forms'
import Button from 'components/Button'
import { Form } from 'components/forms'
import { useTranslation } from 'react-i18next'

const InvalidateClosingModal = ({ unmount, data }) => {
	const [t] = useTranslation()
	const [mutate] = useMutation(invalidateClosing)
	const handleSubmit = ({ reason }) => {
		mutate({
			variables: {
				reason,
				id: data.id,
				date: new Date()
			}
		})
		unmount()
	}
	return (
		<Modal
			width={480}
			unmount={unmount}
			label={t('closing_section.buttons.cancell_closing')}
		>
			<Form onSubmit={handleSubmit}>
				<TextArea
					label={t('closing_section.strings.closing_inactive_reason')}
					field='reason'
				/>
				<Button type='submit' status='primary' text={t('closing_section.buttons.cancell_closing')}/>
				<Button type='button' status='cancelation' text={t('common.buttons.abort')} onClick={unmount}/>
			</Form>
		</Modal>
	)
}

export default InvalidateClosingModal
